export type CreateMotiveErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class CreateMotiveError extends Error {
    code: CreateMotiveErrorCode;

    constructor(code: CreateMotiveErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
